import {
  PieChart,
  Pie,
  Cell,
  Legend,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

const COLORS = [
  "#8884d8",
  "#82ca9d",
  "#ffc658",
  "#ff7f50",
  "#8dd1e1",
  "#a4de6c",
];

const MealPieChart = ({
  mealPlanMap,
  selectedMeals,
  mealPercentages,
  formData,
}) => {
  const data = (mealPlanMap[selectedMeals] || []).map((meal) => {
    const percentage = mealPercentages[meal] || 0;
    const kcal = formData.dailyIntake
      ? ((formData.dailyIntake * percentage) / 100).toFixed(2)
      : 0;
    return {
      name: meal.charAt(0).toUpperCase() + meal.slice(1).toLowerCase(),
      value: parseFloat(kcal),
    };
  });

  return (
    <div style={{ width: "100%", height: 300 }} className="mt-4">
      <h6 className="ms-2 mb-3">Meal Calorie Breakdown</h6>
      <ResponsiveContainer>
        <PieChart>
          <Pie
            data={data}
            dataKey="value"
            nameKey="name"
            cx="50%"
            cy="50%"
            outerRadius={90}
           label={({ value }) => `${value} Cal`}
          >
            {data.map((entry, index) => (
              <Cell
                key={`cell-${index}`}
                fill={COLORS[index % COLORS.length]}
              />
            ))}
          </Pie>
          <Tooltip formatter={(value) => `${value} Cal`} />
          <Legend />
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
};

export default MealPieChart;
